import { faAngleUp, faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import iconComachi from "images/logo.png";
import React, { useState } from 'react';
import Style from "styles/components/header.module.scss";

const Header = () => {
  const [showSmileBanner] = useState(false);
  const bannerClass = classNames({
    [Style.header__nav__top__comachiLink__img]: true,
    [Style.header__nav__top__comachiLink__img__disable]: showSmileBanner,
  });
  
  const [isNavOpne, setIsNavOpen] = useState(false);
  const navIconWidth = 13;
  const navIconHeight = 15;
  return (
    <div className={classNames(Style.header)} style={{ backgroundColor: '#fff' }}>
      <div className={classNames(Style.container)}>
        <div className={classNames(Style.header__nav)}>
          <div className={classNames(Style.header__nav__top)}>
            <div className={classNames(Style.header__nav__top__img)}>
              <a href="/">
                <img className={Style.header__nav__top__logo} src={iconComachi} alt="Comachi ロゴ"/>
              </a>
            </div>
            <div className={classNames({ [Style.header__nav__top__menu]: true, [Style.header__nav__top__menu__active]: isNavOpne })}>
              <ul>
                <li>
                  <a href="/func/">機能</a>
                </li>
                <li>
                  <a href="/design/">デザイン</a>
                </li>
                <li>
                  <a href="/price/">料金</a>
                </li>
                <li>
                  <a href="/case_study/">事例</a>
                </li>
                <li>
                  <a href="/faq/">よくある質問</a>
                </li>
                <li>
                  <a href="/know_how/">運営ノウハウ</a>
                </li>
                <li>
                  <a href="/news/">お知らせ</a>
                </li>
              </ul>
            </div>
            <div className={classNames(Style.header__nav__top__bars)} onClick={() => setIsNavOpen(!isNavOpne)}>
              {isNavOpne ? (
                <FontAwesomeIcon className="fa-fw" icon={faAngleUp} width={navIconWidth} height={navIconHeight} />
              ) : (
                <FontAwesomeIcon className="fa-fw" icon={faBars} width={navIconWidth} height={navIconHeight} />
              )}
            </div>
            <div className={Style.header__nav__top__btns}>
              <a
                className={classNames(Style.header__nav__top__btn, Style.header__nav__top__login)}
                href="https://store.comachicart.com/login"
              >
                ログイン
              </a>
              <a className={classNames(Style.header__nav__top__btn, Style.header__nav__top__application, bannerClass)} href="/application">
                無料でお試し
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
